export type NightWindow = {
  startTime: number;
  endTime: number;
  isTonightAvailable: boolean;
};

/**
 * Current aurora "night" window: 6 PM to 6 AM local time.
 * Matches filtering used on reports, map markers, and submissions lists.
 */
export function getCurrentNightWindow(now: Date = new Date()): NightWindow {
  const currentHour = now.getHours();
  const isTonightAvailable = currentHour >= 18 || currentHour < 6;

  let nightStart: Date;
  let nightEnd: Date;

  if (currentHour >= 18) {
    nightStart = new Date(now);
    nightStart.setHours(18, 0, 0, 0);
    nightEnd = new Date(now);
    nightEnd.setDate(nightEnd.getDate() + 1);
    nightEnd.setHours(6, 0, 0, 0);
  } else {
    nightStart = new Date(now);
    nightStart.setDate(nightStart.getDate() - 1);
    nightStart.setHours(18, 0, 0, 0);
    nightEnd = new Date(now);
    nightEnd.setHours(6, 0, 0, 0);
  }

  return {
    startTime: nightStart.getTime(),
    endTime: nightEnd.getTime(),
    isTonightAvailable,
  };
}

export function isDateTimeInCurrentNight(
  dateTime: number,
  now: Date = new Date(),
): boolean {
  const { startTime, endTime } = getCurrentNightWindow(now);
  return dateTime >= startTime && dateTime <= endTime;
}

/** Report uploaded recently but the observation time is from another night. */
export function isOldPhotoAlert(
  dateTime: number,
  creationTime: number,
  now: Date = new Date(),
): boolean {
  const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
  const submittedRecently = creationTime >= now.getTime() - sevenDaysMs;
  return submittedRecently && !isDateTimeInCurrentNight(dateTime, now);
}
